var inline = {exports: {}};

export { inline as i };
